// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import ShowtimeDialog from './ShowtimeWidget/ShowtimeDialog'
import Button from './controls/SmallRoundedButton'
import { translations, translateFunc } from '../shared/localize'
import NativeSelect from './controls/NativeSelect'
import styled from 'styled-components'

const Counter = styled.div`
  display: inline-block;
  padding: 0 15px;
`

const t = translateFunc({
  ...translations.audience_edit.showtime.translations,
  ...translations.audience_edit.showtime.date_day_short
})

const presets = {
  everytime: _.times(7, () => _.times(24)),
  workdays: _.concat(
    _.times(5, () => _.times(24)),
    _.times(2, () => [])
  ),
  holidays: _.concat(
    _.times(5, () => []),
    _.times(2, () => _.times(24))
  ),
  worktime: _.concat(
    _.times(5, () => _.times(11, (i) => 9 + i)),
    _.times(2, () => [])
  )
}

type ShowtimeType = Array<Array<number>>

type Props = {|
  value: ShowtimeType,
  onChange: (ShowtimeType) => void
|}

type State = {|
  isOpen: boolean
|}

export default class ShowtimeWidget extends Component<Props, State> {
  state = { isOpen: false }

  render() {
    let options = _.concat(_.keys(presets), 'custom_timetable')

    return (
      <div>
        <NativeSelect
          options={_.map(options, (option) => ({ id: option, name: t(option) }))}
          width={200}
          value={this.selectValue()}
          onChange={(value) => this.selectChanged(value)}
        />
        <Counter>
          <span>{this.showtimeInPercents()}</span>
          {t('percents_in_week')}
        </Counter>
        {this.selectValue() === 'custom_timetable' && (
          <Button onClick={() => this.setState({ isOpen: true })}>{t('change')}</Button>
        )}
        <ShowtimeDialog
          isOpen={this.state.isOpen}
          value={this.props.value}
          onChange={(value) => this.valueChanged(value)}
          onClose={() => this.setState({ isOpen: false })}
          translateFunction={t}
        />
      </div>
    )
  }

  selectValue() {
    let result = null
    _.each(presets, (preset, presetCode) => {
      if (_.isEqual(this.props.value, preset)) result = presetCode
    })

    return result || 'custom_timetable'
  }

  selectChanged(value: string) {
    if (value === 'custom_timetable') {
      this.setState({ isOpen: true })
    } else {
      this.props.onChange(presets[value])
    }
  }

  valueChanged(value: ShowtimeType) {
    this.props.onChange(value)
  }

  showtimeInPercents() {
    return Math.round((_.size(_.flattenDeep(this.props.value)) * 100) / (24 * 7))
  }
}
